import { Button, Stack } from "@chakra-ui/react";

const UserBox = function(){

    return <Stack direction={'row'} pr='20px' >
        <Button  variant={'outline'} borderColor={'tema.cor001'}  color={'tema.cor001'} _hover={ {borderColor:'tema.cor002',  color:'tema.cor002'}}>Registre-se</Button>
        <Button  bg={'tema.cor002'}  color={'tema.cor001'} _hover={ {bg:'tema.cor001',  color:'tema.cor002'}}>Login</Button>
    </Stack>
}
export default UserBox;